<template>
  <RenderHTML ref="iconRef" :seotext="icon" :class-wrapper="classes" />
</template>

<script setup lang="ts">
import RenderHTML from '~/components/ui/RenderHTML.vue';

/**
 * @function svg-icon import component
 * @param {string} name this is the name of the svg file in /assets/icons/
 * @return returns render to DOM
 */
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  filled: {
    type: Boolean,
    default: false,
  },
});
const classes = computed(() => {
  const list = ['nuxt-icon'];
  if (!props.filled) list.push('nuxt-icon--fill');
  return list.join(' ');
});
const icon: Record<string, any> = ref('');
try {
  const iconsImport = import.meta.glob('assets/icons/**/**.svg', {
    as: 'raw',
    eager: false,
  });
  const rawIcon = await iconsImport[`/assets/icons/${props.name}.svg`]();
  icon.value = rawIcon;
} catch {
  console.error(
    `[nuxt-icons] Icon '${props.name}' doesn't exist in 'assets/icons'`
  );
}
</script>

<style lang="scss" scoped>
.nuxt-icon {
  :deep(svg) {
    width: 100%;
    height: 100%;
  }
}

/*
.nuxt-icon svg {
  vertical-align: middle;
}
*/

/*.nuxt-icon.nuxt-icon--fill,*/
/*.nuxt-icon.nuxt-icon--fill * {*/
/*  fill: currentColor !important;*/
/*  }*/
</style>
